export default __webpack_public_path__ + "static/161-3c6925a353f2dfefdf06d05cd9b2263e.jpg";